import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { LoadingSpinner } from '@shieldpay/bumblebee/loading-spinner';

import { HiveLayout } from '~/components/layout/layout';

const Layout = () => (
  <HiveLayout>
    <Suspense fallback={<LoadingSpinner size="xxlarge" center />}>
      <Outlet />
    </Suspense>
  </HiveLayout>
);

export default Layout;
